import { connect } from 'react-redux';
import {
    getOrgDataToEdit,
    LABEL_PATH_BY_ORG_TYPE,
    fetchChangeAnchorBySysAdmin,
    fetchEditOrg,
    fetchGetOrgDataById,
    loadingOrg,
    getFetchingErrorOrg,
    clearOrgData, fetchMarkOrgAsBava, fetchRemoveOrgBavaFlag
} from '../../../reducers/organization/organizations';
import {getTranslation} from "../../../reducers/common/localization";
import OrgDetails from "./OrgDetails";
import _ from 'lodash';
import {
    getContinentsData,
    getCountriesData,
    getCurrentContinent,
    setCurrentContinent
} from "../../../reducers/common/location";
import {resetSubmitFormData} from "../../../reducers/common/submitForm";
import {Utils} from "../../../utils/utils";
import {getSubRoles} from "../../../reducers/account/role";

const mapStateToProps = (state, {location}) => {
    let orgData = getOrgDataToEdit(state);
    return {
        id: Utils.getParamsFromLocationSearch(location.search).id,
        labelPath: _.isNil(orgData) ? '' : LABEL_PATH_BY_ORG_TYPE[orgData.orgType],
        data: orgData,
        loading: loadingOrg(state),
        fetchingError: getFetchingErrorOrg(state),
        translation: getTranslation(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        subRoles: getSubRoles(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: (id) => dispatch(fetchGetOrgDataById(id)),
        onSetContinent: (continentCode) => dispatch(setCurrentContinent(continentCode)),
        onOrgEdit: (orgId, orgData) => dispatch(fetchEditOrg(orgId, orgData)),
        onAnchorEdit: (orgId, anchorData) => dispatch(fetchChangeAnchorBySysAdmin(orgId, anchorData)),
        onMarkOrgAsBava: (orgId) => dispatch(fetchMarkOrgAsBava(orgId)),
        onRemoveOrgBavaFlag: () => dispatch(fetchRemoveOrgBavaFlag()),
        onUnmount: () => {
            dispatch(clearOrgData());
            dispatch(resetSubmitFormData());
            dispatch(setCurrentContinent(''));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgDetails);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgDetails/OrgDetails.container.js